/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationRename } from '../../axios/organisationRename'
import type {
	OrganisationRenameError,
	OrganisationRenamePathParams,
	OrganisationRenameRequest,
	OrganisationRenameResponse,
} from '../../types/OrganisationRename'

export const organisationRenameMutationKey = () => [{ url: '/organisations/:organisation/name' }] as const

export type OrganisationRenameMutationKey = ReturnType<typeof organisationRenameMutationKey>

export type OrganisationRenameVariables = {
	organisation: OrganisationRenamePathParams['organisation']
	data: OrganisationRenameRequest
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::rename */
export function useOrganisationRename<TContext = unknown>(
	options?: UseMutationOptions<
		OrganisationRenameResponse,
		AxiosError<OrganisationRenameError>,
		OrganisationRenameVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: organisationRenameMutationKey(),
		mutationFn: ({ organisation, data }: OrganisationRenameVariables) =>
			organisationRename(organisation, data, config).then(res => res.data),
		...options,
	})
}
